export const HOME = {
  eyebrow: "Officium Mentale · Veteran-Owned · Texas",
  headline: ["Better Questions.", "Deeper Understanding.", "Stronger Conversations."],
  category: "Behavioral-health education for veterans and the families beside them.",
  intro: "Behavioral-health education that helps veterans, families, and the people who support them better understand thoughts, emotions, assumptions, and behavioral patterns.",
  pain: "For military transition, life with a service-connected disability, and the people living alongside it — so your next appointment starts with a question you've already written down, not a knot you can't explain.",
  ctaPrimary: "Start the free lesson",
  ctaPrimaryNote: "Introduction + Lesson 1 are free. No account, no card.",
  ctaSecondary: "Explore the Investigation Method™",
  ctaTertiary: "Discover the 20-Lesson Curriculum",

  different: {
    title: "A different way to learn about yourself",
    p1: "Most educational programs explain concepts. Officium Mentale goes a step further: it teaches you how to investigate your own experience.",
    p2: "Instead of automatically accepting your first interpretation, you'll learn to distinguish what happened from what you think it means, examine your assumptions, recognize patterns, and consider your next choice.",
  },

  method: {
    eyebrow: "A structured method—not just a set of questions",
    title: "The Officium Mentale Investigation Method™",
    stages: ["Observe", "Experience", "Interpret", "Trace", "Examine", "Reframe", "Recognize", "Evaluate", "Choose", "Become"],
    caption: "Each stage builds on the investigation, helping you move from noticing an experience toward making a more deliberate choice.",
  },

  changes: {
    eyebrow: "What changes",
    title: "Not just a skill. A different way to sit with the hard moments — for you and for the people beside you.",
    items: [
      { k: "For you", v: "Less alone with what's in your head, and less helpless in the gap between needing help and finding it. The reaction still comes — but now there's a question between you and it." },
      { k: "For the people beside you", v: "Your family or partner sees you working at it, in plain language. When one person stops reacting on autopilot, conversations at home stop escalating as fast." },
      { k: "On your own terms", v: "Nobody tells you what your reaction means — you do the looking, at your own pace, and the account and the reflections are yours. Rebuilding after service on your own terms, not on a schedule somebody else set." },
      { k: "For your next appointment", v: "You walk in with a written question instead of a knot. Providers get to hear what you've noticed, not just that something feels wrong." },
    ],
  },
  institutions: {
    eyebrow: "For schools, agencies and teaming partners",
    title: "Programs for schools, agencies and teaming partners — VOSB certified, SAM.gov active, non-clinical by design.",
    body: "Cohort course access, facilitated series or facilitator training, population adaptation, materials and participation reporting — written to your statement of work and built to sit alongside your licensed providers. A written proposal comes back within two business days.",
  },
  built: {
    title: "Built for real-life reflection",
    items: [
      "20 sequenced lessons with specific learning objectives.",
      "Mind Lab™ exercises to apply concepts to situations you choose.",
      "Practical field applications to help you practice between lessons.",
      "Reflection questions to help you prepare for more informed conversations with qualified professionals when appropriate.",
    ],
  },

  who: {
    title: "Who is it for?",
    lead: "Veterans and families get lost in the space between needing help and finding it. Families and organizations need fewer dead ends, not more paperwork. Everything here is built for that space — and for the people who stand in it with them.",
    audiences: [
      { k: "Veterans", s: "Educational tools for self-awareness, emotional understanding, life transitions, and deliberate decision-making.", to: "/professor-mentale", cta: "Explore the curriculum" },
      { k: "Families and caregivers", s: "Tools for understanding reactions, examining assumptions, and approaching difficult conversations more thoughtfully.", to: "/who-we-serve", cta: "See how we support families" },
      { k: "Organizations and community partners", s: "Structured educational programs and workshops, subject to the scope and delivery capacity of each engagement.", to: "/request-proposal", cta: "Discuss a program" },
    ],
    notFor: "Who it is not for: if you're in crisis right now, call or text 988 (veterans press 1) — that comes first. And if you're looking for a diagnosis or treatment, you need a licensed provider. We teach; we don't treat.",
  },

  start: {
    title: "Start with one question",
    question: "What actually happened before your mind explained what happened?",
    line: "That is where the investigation begins.",
    cta: "Begin with Lesson 1 — it's free",
  },

  disclaimer: "Officium Mentale provides education and reflection tools. It does not diagnose conditions or replace psychotherapy or other qualified care.",
};
